import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getLatestNews } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import { MobilePopMenu } from './Common';



class partnerNews extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      news:[],
    }

    this.getLatestNews();
 
  }

  componentDidMount() {
  }

  getLatestNews = () =>{


      getLatestNews().then((response) => {

          this.setState({news:response.data});

      });

  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render() {
 

      const { news } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">News</h4>
                   
                    
     <table class="table table-hover table-forum text-center">
          
      <thead>
        <tr>
           
          <th class="text-left">Topic</th>
          <th>Comments</th>
        </tr>
      </thead>
      
      <tbody>

       {news.length>0 && news.map((news, i) => {     
                      
        return (
        <tr>
          
          <td class="text-left">
            <a href="#" class="font-weight-bold blue-text">
             {news.news_title}
            </a>
            <div class="my-2">Author:
              <a href="#" class="blue-text">
                <strong>BeWise</strong>
              </a>
               
              <span> at 12/12/2021</span>
              <div></div>
            </div>
          </td>
          <td>
            <a href="#" class="text-dark">
              <span>10</span>
              <i class="fas fa-comments ml-1"></i>
            </a>
          </td>
        </tr>

          )

       } ) }
        

      </tbody>
      
          </table>  

                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerNews;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/news.jsx